export const SAVE_PERSON_DATA = "SAVE_PERSON_DATA";